import { types } from '../actions/AudioEditorActions';
import audioEditorUtils from '../components/audioEditor/utils/AudioEditorUtils';
import uuid from 'uuid';
import playController from '../components/utils/PlayController';
import timelineDragManager from '../components/audioEditor/utils/TimelineDragManager';

export function initTimelines(state, audioEditorState) {
    if (audioEditorState) {
        return Object.assign({}, state, audioEditorUtils.checkAudioControlPoints(audioEditorState));
    } else {
        var timelines = state.timelines;

        if (timelines == undefined)
            timelines = playController.getEmptyTimelines();

        return Object.assign({}, state, {
            timelines: timelines
        });
    }
}

export function changeTimelineVolume(state, index, volume) {
    var timelines = state.timelines;
    var soloIndex = audioEditorUtils.getSoloIndex();

    const newTimelines = timelines.map(timeline => {
        const newTimeline = Object.assign({}, timeline);

        if (newTimeline.index == index) {
            newTimeline.volume = volume;
            newTimeline.isMute = false;
        }

        if (soloIndex >= 0 && soloIndex != index) { // a track it's Solo and the current changed volume is for other track than the SOLO one
            newTimeline.isSolo = false; // make all tracks unSolo
        }

        return newTimeline;
    });

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

export function addRecordedDataIOS(state, data) {
    var timelines = state.timelines;

    const newTimelines = timelines.map(timeline => {
        const newTimeline = Object.assign({}, timeline);

        if (newTimeline.index == 0) {
            newTimeline.recordedDataIos = data;
        }

        return newTimeline;
    });

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

export function changeTitle(state, index, title) {
    var timelines = state.timelines;

    const newTimelines = timelines.map(timeline => {
        const newTimeline = Object.assign({}, timeline);

        if (newTimeline.index == index)
            newTimeline.title = title;

        return newTimeline;
    });

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

export function changeZoomValue(state, value) {
    return Object.assign({}, state, {
        zoomValue: value
    });
}

export function showTrackMenu(state, value) {
    return Object.assign({}, state, {
        trackMenu: value
    });
}

export function addAudioToTimeline(state, index, audio) {
    var timelines = state.timelines;
    var i;
    var newTimelines = [];
    var item;

    if (audio.duration > 0)
        item = audio;
    else
        item = audioEditorUtils.getSlideItem(audio);

    if (playController.isAudioEditorMode())
        audioEditorUtils.animationId = item.uuid;

    for (i=0; i<timelines.length; i++) {
        var newTimeline = Object.assign({}, timelines[i]);
        var newAudios = [];

        newTimeline.isSelected = false;

        for (var j = 0; j < newTimeline.audios.length; j++) {
            var audioItem = Object.assign({}, newTimeline.audios[j]);

            if (audioItem.uuid != item.uuid) {
                if (i == index && item.left == audioItem.left) {
                    // remove the old item
                } else {
                    audioItem.showControlPoint = false;
                    newAudios.push(audioItem);
                }
            }
        }

        if (i == index) {
            item.showControlPoint = true;
            audioEditorUtils.ensureHasContentItem(item);

            newAudios.push(item);
            newTimeline.isSelected = true;
        }

        newTimeline.audios = newAudios;

        newTimelines.push(newTimeline);
    }

    audioEditorUtils.updateMarker();
    playController.updateAudioElements();

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

export function setVolumePoints(state, uuid, points) {
    var timelines = state.timelines;
    var i;
    var j;
    var newTimelines = [];

    for (i=0; i<timelines.length; i++) {
        var newTimeline = Object.assign({}, timelines[i]);
        var audios = timelines[i].audios;
        var newAudios = [];

        for (j=0; j < audios.length; j++) {
            var audio = Object.assign({}, audios[j]);

            if (audio.uuid == uuid)
                audio.points = points;

            newAudios.push(audio);
        }

        newTimeline.audios = newAudios;
        newTimelines.push(newTimeline);
    }

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

export function deleteItem(state, uuid) {
    var timelines = state.timelines;
    var i;
    var j;
    var newTimelines = [];
    var currentItem;

    if (timelines == undefined)
        return Object.assign({}, state);

    for (i=0; i<timelines.length; i++) {
        var newTimeline = Object.assign({}, timelines[i]);
        var audios = timelines[i].audios;
        var newAudios = [];

        newTimeline.isSelected = false;

        for (j=0; j < audios.length; j++) {
            var audio = Object.assign({}, audios[j]);

            if (uuid) {
                if (audio.uuid == uuid) {
                    currentItem = audio;
                } else {
                    newAudios.push(audio);
                }
            } else {
                if (audio.showControlPoint == true) {
                    if (document.activeElement.id.indexOf('audioItemElement') != -1) {
                        if (document.activeElement.id != ('audioItemElement_' + audio.uuid))
                            newAudios.push(audio);
                        else
                            currentItem = audio;
                    } else
                        currentItem = audio;
                } else {
                    newAudios.push(audio);
                }
            }
        }

        newTimeline.audios = newAudios;
        newTimelines.push(newTimeline);
    }

    audioEditorUtils.updateMarker();
    playController.updateAudioElements();

    var markerLastPosition = audioEditorUtils.getTimelinesMaxPosition(newTimelines);

    if (currentItem && markerLastPosition < (currentItem.left + currentItem.duration)) {
        return Object.assign({}, state, {
            timelines: newTimelines,
            markerPosition: markerLastPosition
        });
    } else {
        return Object.assign({}, state, {
            timelines: newTimelines
        });
    }
}

export function updateSoundDuration(state, uuid, duration) { // change the href for the item when a recording is done: change blob url with the correct one from the server
    var timelines = state.timelines;
    var i;
    var j;
    var newTimelines = [];

    if (timelines == undefined)
        return Object.assign({}, state);

    for (i=0; i<timelines.length; i++) {
        var newTimeline = Object.assign({}, timelines[i]);
        var audios = timelines[i].audios;
        var newAudios = [];

        for (j=0; j < audios.length; j++) {
            var audio = Object.assign({}, audios[j]);

            if (audio && audio.uuid == uuid && duration > 0 && duration != audio.duration) {
                audio.duration = duration;
            }

            newAudios.push(audio);
        }

        newTimeline.audios = newAudios;
        newTimelines.push(newTimeline);
    }

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

export function updateItem(state, uuids, newHref) { // change the href for the item when a recording is done: change blob url with the correct one from the server
    var timelines = state.timelines;
    var i;
    var j;
    var newTimelines = [];

    if (timelines == undefined)
        return Object.assign({}, state);

    for (i=0; i<timelines.length; i++) {
        var newTimeline = Object.assign({}, timelines[i]);
        var audios = timelines[i].audios;
        var newAudios = [];

        for (j=0; j < audios.length; j++) {
            var audio = Object.assign({}, audios[j]);

            if (audio && uuids && newHref && uuids.indexOf(audio.uuid) != -1) {
                audio.href = newHref;
                audioEditorUtils.ensureHasContentItem(audio);
            }

            newAudios.push(audio);
        }

        newTimeline.audios = newAudios;
        newTimelines.push(newTimeline);
    }

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

export function selectElement(state, uuid, value) {
    var timelines = state.timelines;
    var i;
    var j;
    var newTimelines = [];

    for (i=0; i<timelines.length; i++) {
        var newTimeline = Object.assign({}, timelines[i]);
        var audios = timelines[i].audios;
        var newAudios = [];
        var currentAudio = undefined;

        newTimeline.isSelected = false;

        for (j=0; j < audios.length; j++) {
            var audio = Object.assign({}, audios[j]);

            if (audio.uuid == uuid) {
                audio.showControlPoint = value;
                currentAudio = audio;
                newTimeline.isSelected = true;
            } else {
                audio.showControlPoint = false;
                newAudios.push(audio);
            }
        }

        if (currentAudio)
            newAudios.push(currentAudio);

        newTimeline.audios = newAudios;
        newTimelines.push(newTimeline);
    }

    audioEditorUtils.updateMarker();

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

export function moveBlock(state, array, offsetX, indexOffset) {
    var timelines = state.timelines;
    var i;
    var j;
    var newTimelines = [];
    var newTimeline;
    var block = [];
    var newAudios = [];
    var audios;
    var selectedTrack = -1;

    for (i=0; i<timelines.length; i++) {
        newTimeline = Object.assign({}, timelines[i]);
        audios = newTimeline.audios;
        newAudios = [];
        var removedItems = [];

        if (newTimeline.isSelected)
            selectedTrack = i + indexOffset;

        for (j = 0; j < audios.length; j++) {
            var audio = Object.assign({}, audios[j]);

            if (array.indexOf(audio.uuid) != -1) {
                audio.left = timelineDragManager.originalPositions[audio.uuid].left + offsetX;
                removedItems.push(audio);
            } else
                newAudios.push(audio);
        }

        if (removedItems.length > 0)
            block[i + indexOffset] = removedItems;

        newTimeline.isSelected = false;
        newTimeline.audios = newAudios;

        newTimelines.push(newTimeline);
    }

    var finalTimelines = [];

    for (i=0; i<newTimelines.length; i++) {
        newTimeline = newTimelines[i];

        if (i == selectedTrack)
            newTimeline.isSelected = true;

        if (block[i]) {
            newTimeline.audios = newTimeline.audios.concat(block[i]);
        }

        finalTimelines.push(newTimeline);
    }


    return Object.assign({}, state, {
        timelines: finalTimelines
    });
}

export function dragAndCloneElement(state, properties) {
    var currentTimelines = JSON.parse(JSON.stringify(state.timelines));
    var i;
    var j;
    var newTimelines = [];
    var newTimeline;
    var currentAudio;

    for (i=0; i<currentTimelines.length; i++) {
        if (properties.startIndex == i) {
            newTimeline = Object.assign({}, currentTimelines[i]);
            var audios = currentTimelines[i].audios;
            var newAudios = [];

            for (j = 0; j < audios.length; j++) {
                var audio = Object.assign({}, audios[j]);

                if (audio.uuid == properties.audio.uuid) {
                    currentAudio = Object.assign({}, audios[j]);

                    currentAudio.uuid = uuid.v4();
                    currentAudio.showControlPoint = true;
                    audio.showControlPoint = false;

                    if (properties.audio.left >= 0)
                        currentAudio.left = properties.audio.left;
                }

                newAudios.push(audio);
            }

            newTimeline.isSelected = false;
            newTimeline.audios = newAudios;

            newTimelines.push(newTimeline);
        } else {
            newTimelines.push(currentTimelines[i]);
        }
    }

    var endTimelines = [];

    if (currentAudio) {
        for (i = 0; i < newTimelines.length; i++) {
            if (properties.endIndex == i) {
                newTimeline = Object.assign({}, newTimelines[i]);
                audioEditorUtils.ensureHasContentItem(currentAudio);
                newTimeline.audios.push(currentAudio);

                newTimeline.isSelected = true;
                endTimelines.push(newTimeline);
            } else {
                endTimelines.push(newTimelines[i]);
            }
        }

        newTimelines = endTimelines;
    }

    audioEditorUtils.updateMarker();
    playController.updateAudioElements();

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

export function changeElementPosition(state, properties) {
    var currentTimelines = JSON.parse(JSON.stringify(state.timelines));
    var i;
    var j;
    var newTimelines = [];
    var newTimeline;
    var currentAudio;

    for (i=0; i<currentTimelines.length; i++) {
        if (properties.startIndex == i) {
            newTimeline = Object.assign({}, currentTimelines[i]);
            var audios = currentTimelines[i].audios;
            var newAudios = [];

            for (j = 0; j < audios.length; j++) {
                var audio = Object.assign({}, audios[j]);

                if (audio.uuid == properties.audio.uuid) {
                    if (properties.audio.left >= 0)
                        audio.left = properties.audio.left;

                    if (audio.points)
                        audio.points = audioEditorUtils.updateVolumePoints(audio.points, audio.inPoint, properties.audio.inPoint, audio.outPoint, properties.audio.outPoint, properties.audio.duration);

                    if (properties.audio.inPoint >= 0)
                        audio.inPoint = properties.audio.inPoint;

                    if (properties.audio.outPoint >= 0)
                        audio.outPoint = properties.audio.outPoint;

                    audio.duration = properties.audio.duration;

                    if (!properties.isKeyboardAction)
                        audio.showControlPoint = true;

                    currentAudio = audio;
                } else
                    newAudios.push(audio);
            }

            newTimeline.isSelected = false;
            newTimeline.audios = newAudios;

            newTimelines.push(newTimeline);
        } else {
            newTimelines.push(currentTimelines[i]);
        }
    }

    var endTimelines = [];

    if (currentAudio) {
        for (i = 0; i < newTimelines.length; i++) {
            if (properties.endIndex == i) {
                newTimeline = Object.assign({}, newTimelines[i]);
                audioEditorUtils.ensureHasContentItem(currentAudio);
                newTimeline.audios.push(currentAudio);

                if (!properties.isKeyboardAction)
                    newTimeline.isSelected = true;

                endTimelines.push(newTimeline);
            } else {
                endTimelines.push(newTimelines[i]);
            }
        }

        newTimelines = endTimelines;
    }

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

export function changeSolo(state, index) {
    var timelines = state.timelines;
    var i;
    var newTimelines = [];

    for (i=0; i<timelines.length; i++) {
        var newTimeline = Object.assign({}, timelines[i]);

        if (i == index) {
            if (newTimeline.isSolo == true)
                newTimeline.isSolo = false;
            else
                newTimeline.isSolo = true;
        } else {
            newTimeline.isSolo = false;
        }

        newTimelines.push(newTimeline);
    }

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

export function changeMute(state, index) {
    var timelines = state.timelines;
    var i;
    var newTimelines = [];

    for (i=0; i<timelines.length; i++) {
        var newTimeline = Object.assign({}, timelines[i]);

        if (i == index) {
            if (newTimeline.isMute == true)
                newTimeline.isMute = false;
            else
                newTimeline.isMute = true;
        }

        newTimelines.push(newTimeline);
    }

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

export function addTrack(state, currentIndex) {
    var timelines = state.timelines;
    var i;
    var newTimelines = [];
    var newTimeline = {index: currentIndex + 1, volume: 1.0, audios: []};
    var maxTimelines = audioEditorUtils.getMaxTimelines();

    if (timelines.length >= maxTimelines)
        return Object.assign({}, state);

    for (i=0; i<timelines.length; i++) {
        var timeline = Object.assign({}, timelines[i]);

        if (i > currentIndex) {
            timeline.index = timeline.index + 1;
        }

        newTimelines.push(timeline);

        if (i == currentIndex)
            newTimelines.push(newTimeline);
    }

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

export function deleteTrack(state, currentIndex) {
    var timelines = state.timelines;
    var i;
    var newTimelines = [];
    var emptyTimeline = {index: 0, volume: 1.0, audios: []};

    if (timelines.length == 1) {
        newTimelines.push(emptyTimeline);
    } else {
        for (i = 0; i < timelines.length; i++) {
            var timeline = Object.assign({}, timelines[i]);

            if (i > currentIndex) {
                timeline.index = timeline.index - 1;
            }

            if (i != currentIndex)
                newTimelines.push(timeline);
        }
    }

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

export function setMarkerPosition(state, position) {
    return Object.assign({}, state, {markerPosition: position});
}

export function splitAudio(state, target, markerPosition) {
    var timelines = state.timelines;
    var i;
    var j;
    var newTimelines = [];

    for (i=0; i<timelines.length; i++) {
        var newTimeline = Object.assign({}, timelines[i]);
        var audios = newTimeline.audios;
        var newAudios = [];
        var leftItem;
        var rightItem;

        for (j=0; j < audios.length; j++) {
            var audio = Object.assign({}, audios[j]);

            if (audio.uuid == target.uuid) {
                leftItem = Object.assign({}, audio);
                leftItem.duration = markerPosition - audio.left;
                leftItem.uuid = uuid.v4();
                leftItem.showControlPoint = true;
                leftItem.points = undefined;
                audioEditorUtils.ensureHasContentItem(leftItem);

                if (audio.outPoint >= 0)
                    leftItem.outPoint = audio.outPoint + (audio.left + audio.duration) - markerPosition;
                else
                    leftItem.outPoint = (audio.left + audio.duration) - markerPosition;

                rightItem = Object.assign({}, audio);
                rightItem.duration = (audio.left + audio.duration) - markerPosition;
                rightItem.left = audio.left + leftItem.duration;
                rightItem.uuid = uuid.v4();
                rightItem.showControlPoint = false;
                rightItem.points = undefined;
                audioEditorUtils.ensureHasContentItem(rightItem);

                if (rightItem.inPoint >= 0)
                    rightItem.inPoint = audio.inPoint + leftItem.duration;
                else
                    rightItem.inPoint = leftItem.duration;

                if (audio.points && audio.points.length > 1) {
                    var controlPoints = audioEditorUtils.getControlPointsForSplitItems(audio.points, leftItem.duration);

                    leftItem.points = controlPoints.left;
                    rightItem.points = controlPoints.right;
                }
            } else {
                newAudios.push(audio);
            }
        }

        if (leftItem && rightItem) {
            newAudios.push(leftItem);
            newAudios.push(rightItem);

            leftItem = undefined;
            rightItem = undefined;
        }

        newTimeline.audios = newAudios;
        newTimelines.push(newTimeline);
    }

    playController.updateAudioElements(10);

    return Object.assign({}, state, {
        timelines: newTimelines
    });
}

function audioEditorUndoRedo(state, appState) {
    const newState = appState.audioEditor;

    playController.updateAudioElements();

    return Object.assign({}, state, newState);
}

export default function(state = {}, action) {
    switch (action.type) {
        case types.INIT_TIMELINES: {
            return initTimelines(state, action.content);
        }

        case types.SET_TIMELINE_WIDTH: {
            return Object.assign({}, state, {timelineWidth: action.width});
        }

        case types.CHANGE_VOLUME: {
            return Object.assign({}, state, {volume: action.volume});
        }

        case types.CHANGE_TIMELINE_VOLUME: {
            return changeTimelineVolume(state, action.index, action.volume);
        }

        case types.RECORDED_DATA_IOS: {
            return addRecordedDataIOS(state, action.data);
        }

        case types.CHANGE_TITLE: {
            return changeTitle(state, action.index, action.title);
        }

        case types.CHANGE_ZOOM: {
            return changeZoomValue(state, action.value);
        }

        case types.ADD_AUDIO_TO_TIMELINE: {
            return addAudioToTimeline(state, action.index, action.audio);
        }

        case types.SELECT_ELEMENT: {
            return selectElement(state, action.uuid, action.value);
        }

        case types.DRAG_AND_CLONE_ELEMENT: {
            return dragAndCloneElement(state, action.properties);
        }

        case types.CHANGE_ELEMENT_POSITION: {
            return changeElementPosition(state, action.properties);
        }

        case types.MOVE_BLOCK: {
            return moveBlock(state, action.array, action.offsetX, action.indexOffset);
        }

        case types.CHANGE_SOLO: {
            return changeSolo(state, action.index);
        }

        case types.CHANGE_MUTE: {
            return changeMute(state, action.index);
        }

        case types.DELETE_ITEM: {
            return deleteItem(state, action.uuid);
        }

        case types.UPDATE_ITEM: {
            return updateItem(state, action.uuids, action.href);
        }

        case types.UPDATE_SOUND_DURATION: {
            return updateSoundDuration(state, action.uuid, action.duration);
        }

        case types.SET_MARKER_POSITION: {
            return setMarkerPosition(state, action.position);
        }

        case types.SPLIT_AUDIO: {
            return splitAudio(state, action.audio, action.markerPosition);
        }

        case types.AUDIO_EDITOR_UNDO_REDO: {
            return audioEditorUndoRedo(state, action.newState);
        }

        case types.SET_VOLUME_POINTS: {
            return setVolumePoints(state, action.uuid, action.points);
        }

        case types.SHOW_TRACK_MENU: {
            return showTrackMenu(state, action.value);
        }

        case types.ADD_TRACK: {
            return addTrack(state, action.index);
        }

        case types.DELETE_TRACK: {
            return deleteTrack(state, action.index);
        }

        case types.REFRESH_AUDIO_TRACK: {
            return Object.assign({}, state, {refreshAudioTrack: action.value});
        }

        case types.REFRESH_AUDIO_ELEMENTS: {
            return Object.assign({}, state, {refreshAudioElements: action.value});
        }

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/AudioEditorReducer.js
 **/